import { render, staticRenderFns } from "./facebook.vue?vue&type=template&id=048071b4&scoped=true&"
import script from "./facebook.vue?vue&type=script&lang=js&"
export * from "./facebook.vue?vue&type=script&lang=js&"
import style0 from "./facebook.vue?vue&type=style&index=0&id=048071b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048071b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048071b4')) {
      api.createRecord('048071b4', component.options)
    } else {
      api.reload('048071b4', component.options)
    }
    module.hot.accept("./facebook.vue?vue&type=template&id=048071b4&scoped=true&", function () {
      api.rerender('048071b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/facebook.vue"
export default component.exports